// extracted by mini-css-extract-plugin
export default {"pageWrap":"pe-z","fullWidth":"qe-z","heading":"re-z","fullBleed":"se-z","hidden":"te-z"};